import React from 'react';
import { motion } from 'framer-motion';
import './Sections.css';
import './VideoFeaturesSection.css';
import { useNavigate } from 'react-router-dom';


const VideoFeaturesSection = () => {
  // Video data with YouTube video IDs
  const videoFeatures = [
    {
      id: 'L4DUb4V_XRE',
      title: 'Orderflow signals',
      description: 'Market Dynamics with RB, IB, RS, and IS'
    },
    {
      id: 'JBLFwHjj0qk',
      title: 'Orderflow Trading',
      description: 'The Power of Order Flow in Derivative Trading: A Game-Changer for Serious Traders'
    },
    {
      id: 'BtFRezXMrxY',
      title: 'COT and Open Interest',
      description: 'Understanding COT and Open Interest in Order Flow Charts'
    }
  ];

  const navigate = useNavigate();

  return (
    <section className="video-features-section" id="video-features">
      {/* Animated gradient elements */}
      <div className="gradient-element"></div>
      <div className="gradient-element"></div>
      
      {/* Decorative orbs */}
      <div className="video-feature-orb top-right"></div>
      <div className="video-feature-orb bottom-left"></div>
      
      <div className="container">
        <motion.div 
          className="section-header"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2>Advanced analytics, <span style={{ color: '#3A86FF' }}>simplified interface</span>.</h2>
          <p>Live, exchange-grade data from NSE—no middlemen, thanks to our tie-up</p>
        </motion.div>
        
        <div className="video-features-grid">
          {videoFeatures.map((video, index) => (
            <motion.div 
              key={index}
              className="video-feature-card"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
            >
              <div className="video-feature-embed">
                <iframe 
                  src={`https://www.youtube.com/embed/${video.id}`}
                  title={video.title}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                  allowFullScreen
                ></iframe>
              </div>
              <div className="video-feature-content">
                <h3>{video.title}</h3>
                <p>{video.description}</p>
              </div>
            </motion.div>
          ))}
        </div>
        
        <motion.div
          className="cta-container"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.3 }}
        >
          <button  onClick={() => navigate('/register')} className="btn btn-primary btn-lg">Explore Now</button>
        </motion.div>
      </div>
    </section>
  );
};

export default VideoFeaturesSection;
